__turbopack_context__.v({
  "collapsed": "k5jn7a_collapsed",
  "markdown": "k5jn7a_markdown",
});
